// extracted by mini-css-extract-plugin
export var cardHeader = "_th-0";
export var reorderHandle = "_th-3";
export var titleArea = "_th-1";
export var titleAreaWithHandle = "_th-2";